import {
  KoumutenAPIRawRequestBodyType,
  KoumutenAPIRequestBodyType
} from '../../types/koumuten/api-request-body';

export const KoumutenAPIRequestBody = ({
  name
}: KoumutenAPIRequestBodyType): KoumutenAPIRawRequestBodyType => ({
  name
});

export const KoumutenAPIRequestBodyPartial = ({
  name
}: Partial<
  KoumutenAPIRequestBodyType
>): Partial<KoumutenAPIRawRequestBodyType> => ({
  name
});
